// Status List
export const ROOT_ADMIN = "Root Admin";
export const ROOT_EMPLOYEE = "Root Employee";
export const AGENCY_ADMIN = "Agency Admin";
export const AGENCY_EMPLOYEE = "Agency Employee";
export const USER_LOGIN = "End User";
